// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { formatISO } from 'date-fns';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import ImageAttribution from '../shared/ImageAttribution';

const IntroSummary = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Image" instructions="Describe an image that aligns with the context of this article." />
      <Controller 
        control={control}
        name="content.media"
        render={({ field }) => <ImageAttribution targetObj="content.media" inputDir={inputDir} errors={errors.content?.media} {...{control }} />}
      />
      
      <NumberedHeading number="2" title="Content" instructions="Enter the summary text content here." />
      <Controller
        control={control}
        name="content.text"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.text} />}
      />
    </div>
  )
};

export default IntroSummary;